module.exports = __webpack_public_path__ + "static/media/USDL.35ab28d6.svg";